import React from 'react'
import PropTypes from 'prop-types'

function SidebarMenuItems ({ active = false, onClick, children }) {
  const classNames = [
    'group',
    'flex',
    'focus:outline-none',
    'transition',
    'ease-in-out',
    'duration-150',
    'flex-col'
  ]

  if (active === true) {
    classNames.push('bg-highlight-100')
  }

  return (
    <div className={classNames.join(' ')} onClick={onClick}>
      {children}
    </div>
  )
}

SidebarMenuItems.defaultProps = {
  active: false
}

SidebarMenuItems.propTypes = {
  active: PropTypes.bool
}

export default SidebarMenuItems
